import { sessionService } from 'redux-react-session';
import { setIsAuthenticated } from 'modules/app';
import apiFetch from '../../../utils/apiFetch';
import {
  loadingAction,
} from '../../../store/globalState/global';

import {
  FETCH_LOGIN_INIT,
  FETCH_LOGIN_SUCCESS,
  FETCH_LOGIN_FAILURE,
} from './types';
import { fetchProfileInit, fetchProfileSuccess } from '../../Profile/modules/actions';

export function fetchLoginInit() {
  return {
    type: FETCH_LOGIN_INIT,
  };
}

export function fetchLoginSuccess() {
  return {
    type: FETCH_LOGIN_SUCCESS,
  };
}

export function fetchLoginFailure(error) {
  return {
    type: FETCH_LOGIN_FAILURE,
    payload: error,
  };
}

export const doLogin = (email, password) => (dispatch, getState) => {
  dispatch(loadingAction(true));
  const data = {
    email,
    password,
    instanceCode: getState().app.code,
  };

  return apiFetch('POST', { endPoint: 'users-login' }, data)
    .then((response) => {
      sessionService.saveSession({ token: response.user_code })
        .then(() => {
          const user = Object.assign({}, response);
          user.instance = getState().app.id;
          sessionService.saveUser(user)
            .then(() => {
              dispatch(loadingAction(false));
              dispatch(setIsAuthenticated(true));
              dispatch(fetchProfileSuccess('Success'));
              window.sendUserIdentifier(user.id);
            });
        });
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      const errorResponse = typeof error.response !== 'undefined' ? error.response.data : '';
      dispatch(fetchLoginFailure(errorResponse));
    });
};

export const doLoginSocial = userId => (dispatch, getState) => {
  dispatch(loadingAction(true));
  const data = {
    instanceCode: getState().app.code,
    userId,
  };
  return apiFetch('GET', { endPoint: 'users/login/social' }, data)
    .then((response) => {
      sessionService.saveSession({ token: response.user_code })
        .then(() => {
          const user = Object.assign({}, response);
          user.instance = getState().app.id;
          sessionService.saveUser(user)
            .then(() => {
              dispatch(loadingAction(false));
              dispatch(setIsAuthenticated(true));
              dispatch(fetchProfileSuccess('Success'));
            });
        });
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      dispatch(fetchLoginFailure(error.response.data));
    });
};

export default function fetchloginAction(event, data) {
  event.preventDefault();
  return (dispatch) => {
    dispatch(loadingAction(true));
    dispatch(fetchProfileInit());
    return new Promise((resolve) => {
      sessionService.saveSession({ token: '123456789' })
        .then(() => {
          sessionService.saveUser(data)
            .then(() => {
              dispatch(fetchProfileSuccess('Success'));
              dispatch(loadingAction(false));
              resolve(true);
            });
        });
    });
  };

}


export function recoverPassword({ email, lang }) {
  const url = 'request_password';

  return apiFetch('GET', { endPoint: url }, { email, lang });
}



// WEBPACK FOOTER //
// ./src/routes/Login/modules/actions.js